export async function updateDiscountCodes(endpoint, storefrontAccessToken, cartId, discountCodes) {
    const query = `
      mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]!) {
        cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
          cart {
            id
            appliedGiftCards {
              id
              amountUsed {  
                amount
                currencyCode
              }
            }
            discountCodes {
              code
              applicable
            }
            cost {
              subtotalAmount {
                amount
                currencyCode
              }
              totalAmount {
                amount
                currencyCode
              }
              checkoutChargeAmount{
                amount
                currencyCode
              }
            }
          }
          userErrors {
            field
            message
          }
          warnings {
            code
            message
          }
        }
      }
    `;

    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": storefrontAccessToken
      },
      body: JSON.stringify({
        query,
        variables: {
          cartId,
          discountCodes
        }
      })
    });
    return response.json();
}